import { STRIPE_KEY } from "../constants.js";

export default ({ email, redirectUrl, clientSecret }) => ({
  stripe: null,
  loading: false,
  errorMessage: null,

  async init() {
    this.loading = true;
    this.stripe = Stripe(STRIPE_KEY);

    this.elements = this.stripe.elements({
      clientSecret,
      appearance: {
        theme: "stripe",
        variables: {
          colorPrimary: "#1e95a6",
        },
      },
    });

    const paymentElement = this.elements.create("payment", {
      layout: "tabs",
      defaultValues: {
        billingDetails: {
          email: email,
        },
      },
    });

    paymentElement.mount(this.$refs.payment);
    this.loading = false;
  },

  async updateForm() {
    this.loading = true;
    await this.elements.fetchUpdates();
    this.loading = false;
  },

  async onSubmit() {
    this.loading = true;
    this.errorMessage = null;

    const { error: submitError } = await this.elements.submit();

    if (submitError) {
      this.errorMessage = submitError.message;
      this.loading = false;

      return;
    }

    const { error } = await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: redirectUrl,
      },
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        this.errorMessage = error.message;
      } else {
        this.errorMessage = "An unexpected error occurred.";
      }

      this.loading = false;
    }
  },
});
